export default {
  namespaced: true,

  getters: {
    type() {
      return (field) => {
        if (!field) {
          return false;
        }

        return field.type || null;
      };
    },

    some(state, getters, rootState, rootGetters) {
      return (field) => {
        if (!field) {
          return false;
        }

        const type = getters.type(field);

        if (!type) {
          return false;
        }

        const config = rootGetters['builder/config'];
        return (
          config.entities.fields.types[type].properties &&
          config.entities.fields.types[type].properties
            .length
        );
      };
    },

    keys(state, getters, rootState, rootGetters) {
      return (field) => {
        if (!getters.some(field)) {
          return [];
        }

        const config = rootGetters['builder/config'];
        const type = getters.type(field);
        return config.entities.fields.types[type]
          .properties;
      };
    },

    property(state, getters, rootState, rootGetters) {
      return (field, key) => {
        if (!getters.some(field)) {
          throw new Error(`Invalid property ${key}`);
        }

        const config = rootGetters['builder/config'];
        const property =
          config.entities.fields.properties[key];

        if (!property) {
          throw new Error(`Invalid property ${key}`);
        }

        return property;
      };
    },

    label(state, getters) {
      return (field, key) => {
        const property = getters.property(field, key);
        return property.label;
      };
    },

    enabled(state, getters, rootState, rootGetters) {
      return (properties, entity, field, key) => {
        if (!getters.some(field)) {
          return false;
        }

        if (!key) {
          return true;
        }

        const property = getters.property(field, key);

        return rootGetters['builder/matcher/matches'](
          property.condition,
          properties,
          entity,
          field,
        );
      };
    },

    required(state, getters) {
      return (field, key) => {
        const property = getters.property(field, key);
        return !!property.required;
      };
    },

    input(state, getters) {
      return (field, key) => {
        const { input } = getters.property(field, key);

        if (!input) {
          return 'text';
        }

        return input.toLowerCase();
      };
    },

    htmlField(state, getters) {
      return (field, key) => {
        const input = getters.input(field, key);

        if (!input) {
          return 'text';
        }

        if (
          [
            'select',
            'entity',
            'field',
            'field_to_display',
          ].includes(input)
        ) {
          return 'select';
        }

        return input;
      };
    },

    help(state, getters) {
      return (field, key) => {
        const property = getters.property(field, key);

        if (!property.help) {
          return null;
        }

        return property.help;
      };
    },

    defaults(state, getters) {
      return (field) => {
        const keys = getters.keys(field);

        if (!keys.length) {
          return {};
        }

        const defaults = {};

        keys.forEach((key) => {
          const defaultValue = getters.defaultValue(
            field,
            key,
          );

          if (!defaultValue && defaultValue !== false) {
            return;
          }

          defaults[key] = defaultValue;
        });

        return defaults;
      };
    },

    defaultValue(state, getters) {
      return (field, key) => {
        const property = getters.property(field, key);
        return property.default;
      };
    },

    displayableValue(state, getters) {
      return (field, key, value) => {
        const htmlField = getters.htmlField(field, key);

        if (htmlField !== 'select') {
          return value;
        }

        const choices = getters.choices(field, key);
        const choice = choices.find(
          (c) => c.value === value,
        );

        if (!choice) {
          return '';
        }

        return choice.label;
      };
    },

    choices(state, getters) {
      return (field, key) =>
        getters.propertyChoices(field, key);
    },

    propertyChoices(state, getters) {
      return (field, key) => {
        const { choices } = getters.property(field, key);

        if (!choices || !Object.keys(choices).length) {
          return [];
        }

        return Object.keys(choices).map((choiceKey) => ({
          value: choiceKey,
          label: choices[choiceKey].label,
        }));
      };
    },
  },
};
